






























































import { Vue, Component } from 'vue-property-decorator';
import { Toast, List, Loading, Popup } from 'vant';
import NewsItem from '../components/NewsItem.vue';
import { getNewsList, getShowList } from '../api';
import { getChannelList } from '../api/util';

Vue.use(Loading)
  .use(List)
  .use(Toast)
  .use(Popup);
@Component({
  components: {
    NewsItem,
    List,
  },
})
export default class ListContent extends Vue {
  newsList: any[] = [];
  loading: boolean = false;
  finished: boolean = false;
  page: number = 1;
  pageSize: number = 6;
  classId: number = 0;
  currentInx: number = 1;
  tabs: any[] = [];
  imgsList: any[] = [];
  isshowimg: boolean = false;
  showimginx: number = -1;
  category: string = '';

  mounted() {
    console.log(this.$route.query.inx);
    this.tabs = getChannelList();
    this.currentInx = this.$route.query.inx
      ? parseInt(this.$route.query.inx + '')
      : 1;
    if (this.currentInx === 1) {
      this.classId = this.tabs[0];
      this.category = '发现最美';
    } else if (this.currentInx === 2) {
      this.classId = this.tabs[1];
      this.category = '最美赛道';
    } else if (this.currentInx === 3) {
      getShowList().then((res: any) => {
        console.log('res::', res);
        if (res.code === 200) {
          if (!res.data) {
            Toast(res.msg);
            return;
          }
          const data = JSON.parse(res.data);
          console.log('data::', data);
          data.forEach((item: any) => {
            this.imgsList.push(item.imageUrl);
          });
        }
      });
    }
  }
  showimgdetail(inx: number) {
    console.log('indx:', inx);
    this.isshowimg = true;
    this.showimginx = inx;
    console.log('isshowimg:', this.isshowimg);
  }
  changeshowimginx() {
    this.isshowimg = false;
    this.showimginx = -1;
  }
  loadData() {
    if (this.currentInx < 3) {
      getNewsList(this.page, this.category, this.classId)
        .then((res: any) => {
          if (res.statusCode !== 200) {
            Toast(res.message);
            return;
          }
          const list =
            res.data &&
            res.data.data instanceof Array &&
            res.data.data.length > 0 &&
            res.data.data[0].list instanceof Array
              ? res.data.data[0].list
              : [];
          this.newsList = [...this.newsList, ...list];
          this.finished = list.length < this.pageSize; // 加载完成
          if (!this.finished) {
            this.page++;
          }
        })
        .catch(() => {
          Toast('网络错误');
          this.loading = false;
          this.finished = true;
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      this.loading = false;
      this.finished = true;
    }
  }
}
